<template>
    <div v-if="!loadingPage" class="pb-2">
        <b-row>
            <b-col md="3" class="mb-2">
                <v-select v-model="parameters.roleId" dir="rtl" :options="roles" :reduce="(value) => value.id"
                    label="name" class="bg-white" style="border-radius: 8px;" :clearable="false">
                    <template #no-options>
                        موردی وجود ندارد
                    </template>
                </v-select>
            </b-col>
            <b-col md="9" class="mb-2">
                <div class="d-flex justify-content-md-end justify-content-center">
                    <b-button @click="showModalCreateUser" variant="primary" class="d-flex align-items-center px-3">
                        <feather-icon size="17" icon="UserPlusIcon" class="mr-50" />
                        <span>ایجاد</span>
                    </b-button>
                </div>
            </b-col>
        </b-row>
        <b-card v-if="usersList.length" class="p-0" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table responsive :items="usersList" :fields="fields" class="mb-0" striped>
                    <template #cell(edit)="data">
                        <feather-icon @click="showModalEdit(data.item)" size="18" icon="EditIcon"
                            class="pointer text-info" color="#8d88a3" />
                    </template>
                </b-table>
            </b-overlay>
        </b-card>
        <b-card v-else class="text-center pt-5 pb-4">
            موردی وجود ندارد
        </b-card>

        <!------------------------------- modal user ------------------------------->
        <b-modal id="management-user" :title="userMode" centered :hide-footer="true" title-class="font-weight-bolder"
            size="md">
            <div class="p-1">
                <!-- roles -->
                <b-form-group label="سطح دسترسی" label-for="rolesId" class="text-center">
                    <v-select v-model="form.roles" dir="rtl" :options="roles" id="rolesId" :reduce="(value) => value.id"
                        style="border-radius: 8px;" label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>

                <!-- firstName -->
                <b-form-group label="نام" label-for="firstNameId" class="text-center">
                    <b-form-input autocomplete="off" dir="rtl" id="firstNameId" v-model="form.firstName"
                        name="firstName" class="text-center user-select-none" />
                </b-form-group>

                <!-- lastName -->
                <b-form-group label="نام خانوادگی" label-for="lastNameId" class="text-center">
                    <b-form-input autocomplete="off" dir="rtl" id="lastNameId" v-model="form.lastName" name="lastName"
                        class="text-center user-select-none" />
                </b-form-group>

                <!-- phoneNumber -->
                <b-form-group label="شماره همراه" label-for="phoneNumberId" class="text-center">
                    <b-form-input v-model="form.phoneNumber" autocomplete="off" dir="ltr"
                        class="text-center user-select-none" />
                </b-form-group>

                <!-- username -->
                <b-form-group label="نام کاربری" label-for="usernameId" class="text-center">
                    <b-form-input autocomplete="off" dir="ltr" id="usernameId" v-model="form.username" name="username"
                        class="text-center user-select-none" />
                </b-form-group>

                <!-- password -->
                <b-form-group label="رمز عبور" label-for="passwordId" class="text-center">
                    <b-form-input autocomplete="off" dir="ltr" id="passwordId" v-model="form.password" name="password"
                        class="text-center user-select-none" />
                </b-form-group>


                <b-button type="submit" variant="info" @click="managementUser" :disabled="loadingButton"
                    class="w-100 mt-2 d-flex align-items-center justify-content-center">
                    <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                    <span>{{ userMode }}</span>
                </b-button>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BTable, BOverlay, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { adminService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        vSelect,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BOverlay,
        BSpinner,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio
    },
    data() {
        return {
            loadingPage: true,
            loading: false,
            loadingButton: false,
            usersList: [],
            fields: [
                {
                    key: 'firstName',
                    label: 'نام',
                },
                {
                    key: 'lastName',
                    label: 'نام خانوادگی',
                },
                {
                    key: 'phoneNumber',
                    label: 'شماره همراه',
                },
                {
                    key: 'username',
                    label: 'نام کاربری',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 9,
                totalCount: null,
                roleId: 1
            },
            form: {
                username: null,
                password: null,
                firstName: null,
                lastName: null,
                phoneNumber: null,
                roles: []
            },
            userMode: null,
            userId: null,
            roles: []
        }
    },
    watch: {
        'parameters.roleId'() {
            this.userManagment()
        }
    },
    methods: {
        showModalDelete(item) {
            this.userId = item.id
            this.form.firstName = item.firstName
            this.form.lastName = item.lastName
            this.$bvModal.show('delete-user')
        },
        managementUser() {
            if (this.userMode == 'ایجاد') {
                this.createUser()
            }
            if (this.userMode == 'ویرایش') {
                this.editUser()
            }
        },
        showModalEdit(item) {
            this.form.roles = []
            this.userMode = 'ویرایش'
            this.userId = item.id
            this.form.username = item.username
            this.form.password = null
            this.form.firstName = item.firstName
            this.form.lastName = item.lastName
            this.form.roles = item.roles[0].id
            this.form.phoneNumber = item.phoneNumber
            this.$bvModal.show('management-user')
        },
        showModalCreateUser() {
            this.userMode = 'ایجاد'
            this.form.username = null
            this.form.password = null
            this.form.firstName = null
            this.form.lastName = null
            this.form.phoneNumber = null
            this.form.roles = []
            this.$bvModal.show('management-user')
        },
        editUser() {
            this.loadingButton = true
            let roles = []
            roles.push(this.form.roles)
            let data = {
                username: this.form.username,
                phoneNumber: this.form.phoneNumber,
                firstName: this.form.firstName,
                lastName: this.form.lastName,
                roles: roles,
                newPassword: this.form.password,
            }
            adminService.updateUser(this.userId, data).then(({ data }) => {
                this.$notif({ type: 'success', title: 'کاربر با موفقیت ویرایش شد' });
                this.$bvModal.hide('management-user')
                this.userManagment()
            })
                .finally(() => {
                    this.loadingButton = false
                });
        },
        createUser() {
            this.loadingButton = true
            let roles = []
            roles.push(this.form.roles)
            let data = {
                username: this.form.username,
                phoneNumber: this.form.phoneNumber,
                firstName: this.form.firstName,
                lastName: this.form.lastName,
                roles: roles,
                password: this.form.password,
            }
            adminService.createNewUser(data).then(({ data }) => {
                this.$notif({ type: 'success', title: 'کاربر با موفقیت ایجاد شد' });
                this.$bvModal.hide('management-user')
                this.userManagment()
            })
                .finally(() => {
                    this.loadingButton = false
                });
        },
        userManagment() {
            this.loading = true
            adminService.userManagment(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.usersList = data.items
                this.loadingPage = false
                this.loading = false
            })
        },
        userManagmentRoles() {
            adminService.userManagmentRoles().then(({ data }) => {
                this.roles = data.roles
                this.userManagment()
            })
        },
    },
    mounted() {
        this.userManagmentRoles()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>